import React from 'react';
import './FaqSection.css';

// Visible FAQ list. Answers stay in the HTML (inside <details>) so crawlers can read them.
// No FAQPage markup: Google retired FAQ rich results in May 2026.
function FaqSection({ title = 'Frequently Asked Questions', faq, className = 'section-white', columns = 1 }) {
  if (!faq || faq.length === 0) return null;

  return (
    <section className={`section ${className}`}>
      <div className={`container faq-container${columns === 2 ? ' faq-two-col' : ''}`}>
        <div className="text-center mb-5">
          <span className="section-tag">FAQ</span>
          <h2 className="section-title heading-font">{title}</h2>
        </div>
        <div className="faq-list">
          {faq.map(({ q, a }) => (
            <details key={q} className="faq-item">
              <summary>
                <h3>{q}</h3>
              </summary>
              <p>{a}</p>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}

export default FaqSection;
